module.exports = __webpack_public_path__ + "assets/fonts/Foco-Regular-4c2198443f026f1e9b09d226212f269c.ttf";